<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý Agent</h1>
      <div class="btn-group float-right">
        <b-btn variant="white" class="f12 font-medium btn btn-outline-secondary" to="/agent/create">
          <i class="bx bx-plus-circle"></i> Thêm mới
        </b-btn>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <div class="box-search">
          <div class="form-group">
            <input
              type="text"
              v-model="search.keywords"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <Select2 :options="stateAgent" v-model="search.stateAgent" placeholder="Trạng thái" />
          </div>
          <form class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              @click.prevent="submitSearchForm"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              @click.prevent="clearSearch"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              type="button"
              class="btn btn-info hc-37 mr-2 pt-2 file-input"
              data-toggle="tooltip"
              @click.prevent="exportExcel"
              data-placement="top"
              title="Nhập file"
            >
              <i class="bx bx-download"></i>
              <span>&nbsp;</span>Xuất file
            </button>
          </form>
        </div>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="table-responsive">
            <div class="box-header">
              Tổng số: <strong class="text-primary">{{ pagination.total }}</strong>
            </div>
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-center">STT</th>
                  <th scope="col">Tên</th>
                  <th scope="col">Email</th>
                  <th scope="col">Số điện thoại</th>
                  <th scope="col">Ngày thêm</th>
                  <th scope="col">Địa chỉ</th>
                  <th scope="col">Thao tác</th>
                </tr>
              </thead>
              <tbody v-if="loading">
                <tr>
                  <td colspan="8" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="table-row" v-for="(item, index) in dataAgent" :key="index">
                  <td class="text-center">
                    {{ search.limit * (search.page - 1) + index + 1 }}
                  </td>
                  <td>
                    <b>{{ item.name }}</b> <br />
                    <p>
                      Mã
                      <router-link :to="`agent/${item.agentId}`" class="text-0A63AB">{{
                        item.agentId
                      }}</router-link>
                    </p>
                    <span v-if="item.stateAgent === 'ACTIVING'" class="badge badge-success"
                      >Đang hoạt động</span
                    >
                    <span v-if="item.stateAgent === 'WAITING_APPROVED'" class="badge badge-primary"
                      >Đang xử lý</span
                    >
                    <span v-if="item.stateAgent === 'LOCKED'" class="badge badge-danger"
                      >Đã khóa</span
                    >
                  </td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.createdDateDTO | formatDate }}</td>
                  <td>{{ item.address }}</td>
                  <td align="right">
                    <b-dropdown class="text-center" variant="outline-light" size="sm">
                      <router-link class="dropdown-item" :to="`agent/${item.agentId}`"
                        ><i class="bx bx-reset"></i><span>&nbsp;</span>Chi tiết</router-link
                      >
                      <button
                        v-if="
                          item.stateAgent !== 'LOCKED' &&
                          dataPermission.includes('CNPS_AGENT_CHANGE_PASSWORD')
                        "
                        class="dropdown-item"
                        @click="resetPass(item)"
                      >
                        <i class="bx bx-reset"></i>
                        <span class="ml-1">&nbsp;</span>Reset mật khẩu
                      </button>
                      <router-link
                        v-if="item.stateAgent === 'ACTIVING'"
                        :to="`agent/update/${item.agentId}`"
                        class="dropdown-item"
                        href="#"
                        ><i class="bx bx-edit-alt"></i><span>&nbsp;</span>Sửa</router-link
                      >
                      <button
                        v-if="item.stateAgent === 'ACTIVING'"
                        class="dropdown-item"
                        @click="blockAgent(item)"
                      >
                        <i class="bx bx-lock-alt"></i>
                        <span class="ml-1">&nbsp;</span>Khóa
                      </button>
                      <button
                        v-if="item.stateAgent === 'WAITING_APPROVED'"
                        class="dropdown-item"
                        @click="approvedAgent(item)"
                      >
                        <i class="bx bx-lock-open-alt"></i>
                        <span class="ml-1">&nbsp;</span>Approved
                      </button>
                      <button
                        class="dropdown-item"
                        @click="openModalAssgni(item)"
                        v-if="
                          item.stateAgent !== 'LOCKED' &&
                          dataPermission.includes('CNPS_AGENT_SET_ROLE')
                        "
                      >
                        <i class="bx bx-lock-alt"></i>
                        <span>&nbsp;</span>Gán quyền
                      </button>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
    <b-modal size="xs" v-model="toastModal.show" scrollable centered title="Thông báo">
      <div class="modal-body text-center">
        <img v-if="toastModal.success" src="@/assets/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-unsuccesss" />
        <h2 class="f18 py-3">{{ toastModal.title }}</h2>
        <p class="text-center">
          {{ toastModal.content }}
        </p>
      </div>
      <template #modal-footer="{ close }">
        <button type="button" class="btn btn-light" @click="close()" data-dismiss="modal">
          Đóng
        </button>
      </template>
    </b-modal>
    <div v-if="showModalAssgi">
      <transition name="modal">
        <div class="modal-mask" style="z-index: 999">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Gán quyền</h5>
                  <button
                    type="button"
                    @click="showModalAssgi = false"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body" style="max-height: 500px; overflow-y: auto">
                  <h1 class="f16 py-3">
                    agent: {{ objectAssgni.name }}
                    <br />
                    <span class="badge badge-primary">Mã Agent: {{ objectAssgni.agentId }}</span>
                  </h1>
                  <ul class="ql-ganquyen" v-for="(item, index) in dataRole" :key="index">
                    <li>
                      <label class="tree-container">
                        {{ item.text }}
                        <input
                          type="checkbox"
                          @click="assgRole(item.text)"
                          :checked="checkedRole(item.text)"
                        />
                        <span class="tree-checkmark"></span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="showModalAssgi = false"
                    data-dismiss="modal"
                  >
                    Hủy
                  </button>
                  <button
                    type="button"
                    @click="submitAssginRole()"
                    class="btn btn-primary"
                    data-dismiss="modal"
                  >
                    Lưu
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import { CommonService } from '@/services/common.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'

  export default {
    name: 'agentList',
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        showModalAssgi: false,
        toastModal: {
          success: false,
          show: false,
          title: null,
          content: null,
        },
        stateAgent: [
          {
            id: 'ACTIVING',
            text: 'Đang hoạt động',
          },
          {
            id: 'WAITING_APPROVED',
            text: 'Đang xử lý',
          },
          {
            id: 'LOCKED',
            text: 'Đã khóa',
          },
        ],
        loading: true,
        dataAgent: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        objectAssgni: {},
        dataRole: [],
        dataAgentRole: [],
        dataRoleAss: [],
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          page: this.search.page,
        })
      },
    },
    created() {
      this.fetchData()
      this.getAllRole()
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      async exportExcel() {
        await AgentService.exportAgent(this.search)
      },
      async submitSearchForm() {
        this.search.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.fetchData()
      },
      setToast(title, content, success) {
        this.toastModal.show = true
        this.toastModal.title = title
        this.toastModal.content = content
        this.toastModal.success = success
      },
      async fetchData() {
        try {
          this.loading = true
          const data = await AgentService.getListAgent(this.search)
          if (data.success) {
            this.dataAgent = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      blockAgent(staff) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: `Bạn chắc chắn muốn khóa agent <b>${staff.name}</b> - <b>${staff.email}</b>?`,
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Khóa agent',
            okTitle: 'Khóa',
            cancelTitle: 'Bỏ qua',
            centered: true,
          })
          .then(async value => {
            if (value) {
              await AgentService.cancelAgent({
                agentId: staff.agentId,
              }).then(response => {
                if (response.success) {
                  this.setToast(null, 'Khóa agent thành công!', true)
                  this.fetchData()
                  return
                }
                this.setToast(null, response.message, false)
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      approvedAgent(staff) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: `Bạn chắc chắn muốn mở khóa agent <b>${staff.name}</b> - <b>${staff.email}</b>?`,
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Mở khóa agent',
            okTitle: 'Mở khóa',
            cancelTitle: 'Bỏ qua',
            centered: true,
          })
          .then(async value => {
            if (value) {
              await AgentService.approvedAgent({
                agentId: staff.agentId,
                isApprovedAgent: true,
                userApproved: JSON.parse(localStorage.getItem('userData')).userId,
              }).then(response => {
                if (response.success) {
                  this.setToast(null, 'Mở khóa agent thành công!', true)
                  this.fetchData()
                  return
                }
                this.setToast(null, response.message, false)
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      resetPass(staff) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: `Bạn chắc chắn muốn reset mật khẩu agent <b>${staff.name}</b> - <b>${staff.email}</b>?`,
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Reset mật khẩu agent',
            okTitle: 'Reset mật khẩu',
            cancelTitle: 'Bỏ qua',
            centered: true,
          })
          .then(async value => {
            if (value) {
              await AgentService.resetPassAgent({
                id: staff.agentId,
              }).then(response => {
                if (response.success) {
                  this.setToast(null, 'Reset mật khẩu agent thành công!', true)
                  return
                }
                this.setToast(null, response.message, false)
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      async openModalAssgni(data) {
        await this.getAgentRole(data.agentId)
        this.objectAssgni = data
        this.dataRoleAss = [...this.dataAgentRole]
        this.showModalAssgi = true
      },
      async getAgentRole(id) {
        try {
          const data = await AgentService.getAgentRole({ id })
          if (data.data.listRole) {
            this.dataAgentRole = data.data.listRole
            return
          }
          this.dataAgentRole = []
        } catch (error) {
          console.log(error)
        }
      },
      async submitAssginRole() {
        try {
          const body = {
            roles: this.dataRoleAss,
            agentId: this.objectAssgni.agentId,
            managerId: JSON.parse(localStorage.getItem('userData')).userId,
          }
          const data = await AgentService.setAgentRole(body)
          if (data.success) {
            this.showModalAssgi = false
            this.setToast(null, 'Gán quyền cho agent thành công!', true)
            return
          }
          this.setToast(null, data.message, false)
        } catch (error) {
          console.log(error)
        }
      },
      assgRole(data) {
        if (this.dataRoleAss.includes(data)) {
          const index = this.dataRoleAss.indexOf(data)
          if (index > -1) {
            this.dataRoleAss.splice(index, 1)
            return
          }
        }
        if (!this.dataRoleAss.includes(data)) {
          this.dataRoleAss.push(data)
        }
      },
      checkedRole(role) {
        return this.dataAgentRole.includes(role)
      },
      async getAllRole() {
        try {
          const data = await CommonService.getAllRole({})
          if (data.data.length > 0) {
            const datas = [{ id: false, text: 'Tất cả' }]
            data.data.map(e => {
              const body = {
                id: e.id,
                text: e.name || '',
              }
              datas.push(body)
            })
            this.dataRole = datas
            return
          }
          this.dataRole = []
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
